import {
  types,
  // getParent
} from 'mobx-state-tree';

const DailyProfit = types.model('DailyProfit', {
  dailyOrders: types.optional(types.frozen,{}),
  weeklyOrders: types.optional(types.frozen,{}),
  monthlyOrders: types.optional(types.frozen,{}),
  yearlyOrders: types.optional(types.frozen,{}),
}).views(self => ({
  get noDailyProfitData() {
    return (Object.values(self.dailyOrders).every(el=>!el.profit));
  },
  get dailyData() {
    return Object.keys(self.dailyOrders).map(key=>({
      profit: self.dailyOrders[key].profit,
      name: key
    }))
  },
  get weeklyData() {
    return Object.keys(self.weeklyOrders).map(key=>({
      profit: self.weeklyOrders[key].profit,
      name: key
    }))
  },
  get monthlyData() {
    return Object.keys(self.monthlyOrders).map(key=>({
      profit: self.monthlyOrders[key].profit,
      name: key
    }))
  },
  get threeMonthlyData() {
    // return Object.keys(self.weeklyOrders).map(key=>({
    //   profit: self.weeklyOrders[key],
    //   name: weekDays[key]
    // }))
    return [];
  },
  get yearlyData() {
    return Object.keys(self.yearlyOrders).map(key=>({
      profit: self.yearlyOrders[key].profit,
      name: key
    }))
  },
  get advWeeklyData() {
    return Object.keys(self.weeklyOrders).map((key)=>({
      name: key,
      ...(self.weeklyOrders[key]),
      // negativeProfit: self.weeklyOrders[key].profit < 0,
      graphProfit: Math.max(self.weeklyOrders[key].profit, 0),
      graphOutline: Math.max(self.weeklyOrders[key].profit, 0) + self.weeklyOrders[key].productCost + self.weeklyOrders[key].paypalFees + self.weeklyOrders[key].destinationFees
    }))
  },
  get advMonthlyData() {
    return Object.keys(self.monthlyOrders).map((key)=>({
      name: key,
      ...(self.monthlyOrders[key]),
      // negativeProfit: self.monthlyOrders[key].profit < 0,
      graphProfit: Math.max(self.monthlyOrders[key].profit, 0),
      graphOutline: Math.max(self.monthlyOrders[key].profit, 0) + self.monthlyOrders[key].productCost + self.monthlyOrders[key].paypalFees + self.monthlyOrders[key].destinationFees
    }))
  },
  get advYearlyData() {
    return Object.keys(self.yearlyOrders).map((key)=>({
      name: key,
      ...(self.yearlyOrders[key]),
      // negativeProfit: self.yearlyOrders[key].profit < 0,
      graphProfit: Math.max(self.yearlyOrders[key].profit, 0),
      graphOutline: Math.max(self.yearlyOrders[key].profit, 0) + self.yearlyOrders[key].productCost + self.yearlyOrders[key].paypalFees + self.yearlyOrders[key].destinationFees
    }))
  },
  get noAdvWeeklyData() {
    return Object.values(self.weeklyOrders).every(el=> (
      !el.destinationFees &&
      !el.ordersNum &&
      !el.paypalFees &&
      !el.productCost &&
      !el.profit &&
      !el.revenue
    ))
  },
  get noAdvMonthlyData() {
    return Object.values(self.monthlyOrders).every(el=> (
      !el.destinationFees &&
      !el.ordersNum &&
      !el.paypalFees &&
      !el.productCost &&
      !el.profit &&
      !el.revenue
    ))
  },
  get noAdvYearlyData() {
    return Object.values(self.yearlyOrders).every(el=> (
      !el.destinationFees &&
      !el.ordersNum &&
      !el.paypalFees &&
      !el.productCost &&
      !el.profit &&
      !el.revenue
    ))
  },
  get missingAdvDataArray() {
    return [self.noAdvWeeklyData, self.noAdvMonthlyData, self.noAdvYearlyData]
  },
  get someAdvDataMissing() {
    return self.noAdvWeeklyData || self.noAdvMonthlyData || self.noAdvYearlyData
  },
}))

export default DailyProfit;
